import React, { FC, useEffect } from 'react';
import { logout } from '../store/actions/authentication';
import { connect } from 'react-redux';
import { IonLoading } from '@ionic/react';
import { RouteComponentProps } from 'react-router';

const mapDispatchToProps = (dispatch: Function, ownProps: any) => ({
  logout: () => dispatch(logout())
});

const Logout: FC<
  ReturnType<typeof mapDispatchToProps> & RouteComponentProps
> = ({ logout, history }) => {
  useEffect(() => {
    logout();
    history.push('/');
  }, [history, logout]);

  return <IonLoading isOpen={true} />;
};

export default connect(null, mapDispatchToProps)(Logout);
